// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-PageComponents-Button----button-module---container---1iwIp","button":"src-components-PageComponents-Button----button-module---button---3HEtN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PageComponents/Button/button.module.css
// module id = 104
// module chunks = 35783957827783 96068746775097